<!--
 * @Descripttion: 添加常用应用
 * @Author: liaoyijun
 * @Date: 2021-08-19 16:29:50
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-17 16:18:49
-->

<template>
    <el-dialog
        :title="''"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :append-to-body="true"
        :visible.sync="visible"
        width="1000px"
        @close="closeDialog"
    >
        <div slot="title">
            <h4>
                {{ title }}
                <el-button v-show="!checkformatService()" size="small" @click="authAppy">权限申请</el-button>
            </h4>
        </div>
        <div>
            <el-input
                v-model="appName"
                placeholder="请输入应用名称"
                prefix-icon="el-icon-search"
                size="small"
                @input="search"
            >
            </el-input>

            <el-container v-if="isShow">
                <el-aside width="180px" :class="{ 'aside-no-data': navBarList.length === 0 }">
                    <div class="nav">
                        <template v-for="(item, index) in navBarList">
                            <div
                                :key="index"
                                :class="['navbarlist', { active: item.active }]"
                                @click="handleClick(item)"
                            >
                                <span>{{ item.groupName }}</span> <span>{{ item.countSum }}</span>
                            </div>
                        </template>
                        <div v-show="navBarList.length === 0" class="noData">
                            <no-empty>暂无数据</no-empty>
                        </div>
                    </div>
                </el-aside>
                <div v-loading="loading" :class="['main', { center: appList.length === 0 }]">
                    <template v-for="(item, index) of appList">
                        <add-app-list :key="index" :item="item" :app-type="appType" @refresh="loadData"></add-app-list>
                    </template>
                    <div v-show="appList.length === 0" class="noData">
                        <no-empty>暂无数据</no-empty>
                    </div>
                </div>
            </el-container>

            <div v-if="!isShow">
                <div v-loading="loading" :class="['wraps', { center: searchAppList.length === 0 }]">
                    <template v-for="(item, index) of searchAppList">
                        <add-app-list
                            :key="index"
                            :item="item"
                            :app-type="appType"
                            status="search"
                            @refresh="searchData"
                        ></add-app-list>
                    </template>
                    <div v-show="searchAppList.length === 0" class="noData">
                        <no-empty>暂无数据</no-empty>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getNavBarList, getRightAppList, SearchAppList } from "@/api";
// import { getLocalStorage } from "@/libs/mUtils";
import NoEmpty from "@/components/no-empty";
import AddAppList from "./addapp-list.vue";
export default {
    components: { AddAppList, NoEmpty },
    props: {
        title: {
            type: String,
            default: "添加常用应用",
        },
    },
    data() {
        return {
            loading: false,
            visible: false,
            tabPosition: "left",
            navBarList: [],
            appList: [],
            searchAppList: [],
            groupId: "",
            appType: "",
            showId: "",
            appName: "",
            isShow: true,
        };
    },
    methods: {
        loadData(status = true) {
            this.getAllAppList(status);
            this.$emit("callback");
        },
        searchData() {
            this.search();
            this.$emit("callback");
        },
        show(index) {
            this.visible = true;
            this.isShow = true;
            this.appType = index;
            this.appName = "";
            this.getNavLists();
        },
        closeDialog() {
            this.visible = false;
            this.$emit("close", false);
        },
        //获取导航栏数据
        getNavLists() {
            getNavBarList().then((res) => {
                this.navBarList = res.body.map((item, index) => {
                    return {
                        ...item,
                        active: index === 0,
                    };
                });
                this.groupId = res.body[0].id;
                this.getAllAppList();
            });
        },
        //获取应用接口
        getAllAppList(status = true) {
            if (status) {
                this.loading = true;
            }

            let info = {
                appType: this.appType,
                groupId: this.groupId,
            };
            getRightAppList(info).then((res) => {
                this.appList = res.body;
                if (status) {
                    this.loading = false;
                }
            });
        },
        handleClick(item) {
            const nodeId = this.navBarList.find((item) => item.active)["id"];
            if (nodeId === item.id) {
                return;
            }
            this.navBarList = this.navBarList.map((node) => {
                return {
                    ...node,
                    active: item.id === node.id,
                };
            });
            this.groupId = item.id;
            document.querySelector(".main").scrollTo(0, 0);
            this.getAllAppList();
        },
        //输入框搜索
        search() {
            let info = {
                appName: this.appName,
                appType: this.appType,
            };
            if (this.appName) {
                this.isShow = false;
                SearchAppList(info).then((res) => {
                    this.searchAppList = res.body;
                });
            } else {
                this.searchAppList = [];
                this.isShow = true;
                this.getAllAppList();
            }
        },
        handleSubmit() {
            this.visible = false;
            this.$emit("callback");
        },
        authAppy() {
            const isProd = process.env.VUE_APP_ENV_NAME === "production";
            const _url = isProd ? `${this.$config.appyAppUrl}&token=${this.accessAuthToken}` : this.$config.appyAppUrl;
            window.open(_url);
            // const auth_user = getLocalStorage("user") || {};
            // const pathName = auth_user.userData.departmentPathName;
            // if (pathName.indexOf("地产总部") > -1) {
            //     window.open(this.$config.HQPermissionUrl); // 地产总部
            // } else {
            //     window.open(this.$config.cityPermissionUrl); // 城市公司
            // }
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__active-bar {
    background-color: transparent !important;
}
/deep/ .el-dialog__header {
    text-align: center;
    .el-dialog__title,
    h4 {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
    }
    h4 {
        position: relative;
        width: 100%;
        height: 100%;
        .el-button {
            position: absolute;
            top: -7px;
            right: 50px;
            color: #54aa91;
        }
    }
    .el-dialog__close {
        position: relative;
        top: -10px;
    }
}
/deep/ .el-dialog__header {
    border-radius: 8px 8px 0 0;
}
/deep/ .el-dialog {
    border-radius: 8px;
}
/deep/.el-table__fixed,
/deep/.el-table__fixed-right {
    height: 100% !important;
    border: none !important;
}
/deep/.is-active {
    background-color: #ddeee9 !important;
}
/deep/ .el-tabs--left .el-tabs__item.is-left {
    text-align: left !important;
}
/deep/.el-tabs--left .el-tabs__header.is-left {
    margin-right: 0px !important;
}
.nav {
    text-align: center;
    margin: 10px 0;
}
.aside-no-data {
    display: flex;
    justify-content: center;
    align-items: center;
}
.el-container {
    border: 1px solid #e4e7ed;
    margin-top: 15px;
    height: 100%;
}
.main {
    height: 400px;
    width: 778px;
    padding: 29px 0;
    background-color: #eef7f7;
    overflow-y: auto;
    z-index: 999;
    &.center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.wraps {
    height: 445px;
    width: 100%;
    margin-top: 10px;
    padding: 29px 0;
    background-color: #eef7f7;
    overflow-y: auto;
    &.center {
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
.navbarlist {
    width: 156px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 36px;
    padding: 0 12px 0 12px;
    margin-left: 10px;
    border-radius: 4px;
}
.navbarlist:hover {
    color: #54aa91;
    border-radius: 4px;
    cursor: pointer;
}
.active {
    color: #54aa91;
    border-radius: 4px;
    background: rgba(84, 170, 145, 0.2);
    cursor: pointer;
}
</style>
